const config = {
  imgUploadURL: ''
}

export default config

export function updateEditorConfig (obj) {
  for (let key in obj) {
    config[key] = obj[key]
  }
}
